import Naluri from '~/common/api/naluri';
import {
  THOUGHT_JOURNAL_GET_JOURNALS_BEGIN,
  THOUGHT_JOURNAL_GET_JOURNALS_SUCCESS,
  THOUGHT_JOURNAL_GET_JOURNALS_FAILURE,
  THOUGHT_JOURNAL_GET_JOURNALS_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getJournals(userID, pageNumber) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: THOUGHT_JOURNAL_GET_JOURNALS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.get(`/api/expert/thoughts?page=${pageNumber}&user_id=${userID}`);
      doRequest.then(
        res => {
          dispatch({
            type: THOUGHT_JOURNAL_GET_JOURNALS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: THOUGHT_JOURNAL_GET_JOURNALS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetJournalsError() {
  return {
    type: THOUGHT_JOURNAL_GET_JOURNALS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case THOUGHT_JOURNAL_GET_JOURNALS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        listing: state.listing.clear(),
        getJournalsPending: true,
        getJournalsError: null,
      };

    case THOUGHT_JOURNAL_GET_JOURNALS_SUCCESS:
      // The request is success
      const list = state.listing.withMutations(journal =>
        action.data.data.map(d => {
          let isExist = journal.find(n => n.id === d.id);
          return !isExist ? journal.push(d) : null;
        }),
      );

      const pagination = action.data.pagination.filter(
        pageItem =>
          !pageItem.current &&
          pageItem.label !== 'Next' &&
          pageItem.label !== 'Previous' &&
          pageItem.label !== '0',
      );

      return {
        ...state,
        listing: list,
        totalPage: pagination.length + 1,
        currentPage: state.currentPage + 1,
        getJournalsPending: false,
        getJournalsError: null,
      };

    case THOUGHT_JOURNAL_GET_JOURNALS_FAILURE:
      // The request is failed
      return {
        ...state,
        getJournalsPending: false,
        getJournalsError: action.data.error,
      };

    case THOUGHT_JOURNAL_GET_JOURNALS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getJournalsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/thought-journal/redux/getJournals.js